import React, { useMemo } from 'react';

export default function EstadisticasTendencia({ stros }) {
  const trendData = useMemo(() => {
    if (!stros) return [];

    // Generate last 6 months chronologically (oldest first)
    const list = [];
    const today = new Date();
    let currentYear = today.getFullYear();
    let currentMonth = today.getMonth() + 1; // 1-based

    for (let i = 0; i < 6; i++) {
      list.unshift({ year: currentYear, month: currentMonth });
      currentMonth--;
      if (currentMonth === 0) {
        currentMonth = 12;
        currentYear--;
      }
    }

    // Aggregate counts for each month
    return list.map(({ year, month }) => {
      const monthStr = month.toString().padStart(2, '0');
      
      // Get short month name in Spanish
      const dateObj = new Date(year, month - 1, 1);
      const monthLabel = dateObj.toLocaleString('es-AR', { month: 'short' });
      const yearLabel = year.toString().slice(-2);
      
      const matchPrefix = `${year}-${monthStr}`;

      const count = stros.filter(s => {
        // Fallback sequence for dates
        const dateStr = s.fechaStro || s.fechaRecepcion || '';
        return dateStr.startsWith(matchPrefix);
      }).length;

      return {
        label: `${monthLabel} '${yearLabel}`,
        count,
      };
    });
  }, [stros]);

  const maxCount = useMemo(() => {
    if (trendData.length === 0) return 1;
    const max = Math.max(...trendData.map(d => d.count));
    return max > 0 ? max : 1;
  }, [trendData]);

  if (!stros || stros.length === 0) {
    return (
      <div className="est-card">
        <div className="est-card-header">
          <span className="est-card-title">
            <i className="bi bi-graph-up"></i>
            Tendencia de Siniestros (Últimos 6 meses)
          </span>
        </div>
        <div className="est-empty">
          <i className="bi bi-inbox"></i>
          <p>No hay datos de siniestros</p>
        </div>
      </div>
    );
  }

  return (
    <div className="est-card">
      <div className="est-card-header">
        <span className="est-card-title">
          <i className="bi bi-graph-up"></i>
          Tendencia de Siniestros (Últimos 6 meses)
        </span>
        <span className="est-card-badge">
          Historial mensual
        </span>
      </div>

      <div className="est-trend-chart-container">
        {trendData.map((item, idx) => {
          const barHeightPercent = (item.count / maxCount) * 100;

          return (
            <div className="est-trend-column" key={item.label}>
              <div className="est-trend-bar-wrapper">
                <div
                  className="est-trend-bar"
                  style={{
                    height: `${Math.max(barHeightPercent, 4)}%`, // At least a tiny height so it's clickable/visible
                  }}
                >
                  <div className="est-trend-tooltip">
                    {item.count} {item.count === 1 ? 'siniestro' : 'siniestros'}
                  </div>
                </div>
              </div>
              <span className="est-trend-label">{item.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
